var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bottomShopList" }, [
    _vm.bottomShopList.shopListStyle === 1
      ? _c("div", [
          _c("img", {
            staticStyle: { width: "100%", height: "393px" },
            attrs: { src: require("@/assets/appNew/Horizontal.png"), alt: "" },
          }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.bottomShopList.shopListStyle === 0
      ? _c("div", [
          _c("img", {
            staticStyle: { width: "100%", height: "499px" },
            attrs: { src: require("@/assets/appNew/Vertical.png"), alt: "" },
          }),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }